import * as flexsearch from "flexsearch";

import { search as searchApi } from "apis-v2/callables";
import { IPresentation, IWorkspaceResourcePresentationTemplate, IWorkspaceResourceWithDocument } from "common/interfaces";
import { IPresentationTemplatesSearchDocument } from "common/interfaces/search/ISearchDocument";

import { BaseWorkspaceResourcesController, BaseWorkspaceResourcesControllerState } from "./BaseWorkspaceResourcesController";

export type IPresentationTemplatesPanePresentation = Pick<IPresentation, "id" | "modifiedAt" | "userId" | "modifiedBy" | "slideRefs">;

export type PresentationTemplatesPaneControllerState = BaseWorkspaceResourcesControllerState<IPresentationTemplatesPanePresentation, IWorkspaceResourcePresentationTemplate>;

class PresentationTemplatesPaneController extends BaseWorkspaceResourcesController<IPresentationTemplatesPanePresentation, IWorkspaceResourcePresentationTemplate, IPresentationTemplatesSearchDocument> {
    protected get _documentFields(): (keyof IPresentationTemplatesPanePresentation)[] {
        return ["id", "modifiedAt", "userId", "modifiedBy", "slideRefs"];
    }

    protected get _batchSize() {
        return 10;
    }

    protected _searchDocumentToResourceWithDocument(searchDocument: IPresentationTemplatesSearchDocument): IWorkspaceResourceWithDocument<IPresentationTemplatesPanePresentation, IWorkspaceResourcePresentationTemplate> {
        return {
            resource: searchDocument.resource,
            permission: searchDocument.permission,
            document: searchDocument.presentation,
        };
    }

    protected async _fetchSearchIndex({ locale, workspaceId }: { locale: string, workspaceId: string }): Promise<{ indexConfig: flexsearch.DocumentOptions<any>, indexFileReadUrl: string }> {
        return searchApi.getPresentationTemplatesSearchIndex({ workspaceId, locale });
    }
}

const presentationTemplatesPaneController = new PresentationTemplatesPaneController();
export default presentationTemplatesPaneController;
